import {registerNode} from "@cm/graph-v2-final"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-patches/definition"
import {ImageOpExtractPatchesHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-patches/hal"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"

@registerNode
export class ImageOpNodeExtractPatches extends BasicSpecializingImageOpNode<typeof Definition, ImageOpExtractPatchesHal> {
    static nodeClass = "ImageOpNodeExtractPatches"
    static definition = Definition

    constructor(parameters: ImageOpInputsOrNodes<typeof Definition>) {
        super(ImageOpExtractPatchesHal, parameters)
    }
}
